/** @jsxImportSource @emotion/react */
import { DeleteOutlined } from '@ant-design/icons'
import { Button, notification, Pagination, Popconfirm, Table } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAllGroupsQuery, useDeleteGroupMutation } from 'services/authz'
import CreateNewGroup from './CreatePopup'

export default function GroupManagements() {
  const [openCreateModal, setOpenCreateModal] = useState(false)
  const [page, setPage] = useState(1)

  const { data, isLoading, isFetching, refetch } = useAllGroupsQuery({
    page,
    size: 10,
  })
  const [deleteGroup, { isLoading: isDeleting, data: deleteGroupResponse }] =
    useDeleteGroupMutation()

  const handleDelete = (groupId: string) => {
    return deleteGroup(groupId)
  }
  useEffect(() => {
    if (deleteGroupResponse && deleteGroupResponse.errors === null) {
      refetch()
      notification.success({
        message: 'Success',
        description: `Successfully deleted group`,
      })
    }
  }, [deleteGroupResponse, refetch])

  const onCancel = useCallback(
    (withRefresh: boolean) => {
      setOpenCreateModal(false)
      if (withRefresh) refetch()
    },
    [refetch]
  )

  return (
    <div css={{ padding: '1rem' }}>
      <CreateNewGroup open={openCreateModal} onClose={onCancel} />
      <div
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem',
        }}
      >
        <div css={{ fontSize: '1.25rem', fontWeight: '500' }}>
          Group Managements
        </div>
        <Button type="primary" onClick={() => setOpenCreateModal(true)}>
          Create new group
        </Button>
      </div>
      <Table
        loading={isLoading || isFetching}
        dataSource={data?.data}
        rowKey="id"
        css={{ marginTop: '1rem' }}
        columns={[
          {
            title: 'ID',
            dataIndex: 'id',
            render: (text) => {
              return <Link to={`/admin/groups/${text}`}>{text}</Link>
            },
          },
          {
            title: 'Name',
            dataIndex: 'name',
          },
          {
            title: 'Description',
            dataIndex: 'description',
          },
          {
            title: 'Action',
            align: 'right',
            render: (_text, record) => (
              <Popconfirm
                onConfirm={() => handleDelete(record.id)}
                title="Delete group"
                description={`Are you sure to delete this group`}
                okButtonProps={{ loading: isDeleting }}
              >
                <Button danger size="small" icon={<DeleteOutlined />}>
                  Delete
                </Button>
              </Popconfirm>
            ),
          },
        ]}
        pagination={false}
      />

      <Pagination
        css={{ marginTop: '1rem', textAlign: 'right' }}
        pageSize={10}
        current={page}
        onChange={(page) => setPage(page)}
        total={data?.pagination.total}
        showTotal={(total) => `Total ${total} groups`}
      />
    </div>
  )
}
